/* ════════════════════════════════════════════════════════════════════════
   KILIM — MOUVEMENT
   Relevé de cocoonblanket.com le 23/09/2026, dans leur theme.js :

     Défilement   natif. Lenis (`lerp: 0.1`, comme Cocoon) a été posé puis
                  retiré le 23/09/2026 à la demande : le défilement lissé ne
                  plaisait pas.
     Tiroir       « shift modal » : le panneau glisse de -100 % à 0 et POUSSE
                  la page et l'en-tête de sa propre largeur ; le voile passe
                  de 0 à 1 avec un flou de 0 à 0,5 rem. 0,8 s, power2.inOut.
                  Le panier (kilim-tiroir.js) fait le même geste par la droite.

   Les durées et courbes vivent dans commun.css (--mouvement-*) : ici on ne
   pose que des attributs, le CSS fait le reste.

   Sans ce script, rien ne casse : le filtre s'ouvre par son <details>.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  var racine = document.documentElement;

  /* ── Le tiroir des filtres, qui pousse la page ──────────────────────── */
  var filtres = document.getElementById('filtres');
  if (!filtres) return;
  var bouton = filtres.querySelector('summary');
  var panneau = filtres.querySelector('.filtres__panneau');
  var voile = filtres.querySelector('.filtres__voile');
  if (!bouton || !panneau || !voile) return;

  /* Sortis de <main> : la page va être translatée, et un élément `fixed`
     dans un parent transformé suivrait la translation au lieu de rester
     collé au bord de l'écran. Cocoon fait le même déplacement. */
  document.body.appendChild(voile);
  document.body.appendChild(panneau);
  panneau.setAttribute('aria-hidden', 'true');
  racine.classList.add('js-panneau');
  bouton.setAttribute('aria-expanded', 'false');


  function ouvrir() {
    racine.style.setProperty('--poussee', panneau.getBoundingClientRect().width + 'px');
    racine.dataset.panneau = 'filtres';
    panneau.setAttribute('aria-hidden', 'false');
    bouton.setAttribute('aria-expanded', 'true');
    var premier = panneau.querySelector('button, [href], input:not([type="hidden"])');
    if (premier) premier.focus({ preventScroll: true });
  }

  function fermer() {
    if (racine.dataset.panneau !== 'filtres') return;
    delete racine.dataset.panneau;
    panneau.setAttribute('aria-hidden', 'true');
    bouton.setAttribute('aria-expanded', 'false');
    bouton.focus({ preventScroll: true });
  }

  bouton.addEventListener('click', function (e) {
    e.preventDefault();
    if (racine.dataset.panneau === 'filtres') fermer(); else ouvrir();
  });
  voile.addEventListener('click', fermer);
  Array.prototype.forEach.call(panneau.querySelectorAll('[data-fermer]'), function (el) {
    el.addEventListener('click', fermer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fermer();
  });
})();

/* ── TOUS LES ACCORDÉONS S'OUVRENT EN HAUTEUR (06/10/2026) ──────────────
   Les <details> du site (panneaux de la fiche, FAQ, sommaire des articles)
   s'ouvraient d'un coup. Ils restent des <details> natifs : le contenu est
   dans le document replié ou non, et sans ce script ils s'ouvrent comme
   avant. Le script ne fait qu'animer la hauteur entre les deux états.

   WAAPI plutôt que CSS : `height: auto` ne se transitionne pas dans Safari,
   et ::details-content n'y existe que depuis la 18.4. Une animation Web
   s'interrompt proprement : un second clic pendant la course repart de la
   hauteur courante.

   Exclus : le tiroir des filtres (#filtres), qui a sa propre mécanique. */
(function () {
  var reduit = matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', function (e) {
    var resume = e.target.closest('details > summary');
    if (!resume || reduit.matches) return;
    var d = resume.parentElement;
    if (d.id === 'filtres' || d.closest('#filtres')) return;
    e.preventDefault();

    var cible = d.dataset.cible ? d.dataset.cible !== 'ouvert' : !d.open;
    var depart = d.getBoundingClientRect().height;
    if (d._anim) d._anim.cancel();

    d.open = cible;
    var arrivee = d.getBoundingClientRect().height;
    if (!cible) d.open = true;   // le contenu reste visible pendant la fermeture
    d.dataset.cible = cible ? 'ouvert' : 'ferme';
    d.style.overflow = 'hidden';

    var a = d.animate({ height: [depart + 'px', arrivee + 'px'] }, {
      duration: cible ? 260 : 200,
      easing: 'cubic-bezier(.23, 1, .32, 1)'
    });
    d._anim = a;
    a.onfinish = function () {
      if (!cible) d.open = false;
      d.style.overflow = '';
      delete d.dataset.cible;
      d._anim = null;
    };
  });
})();
